/**
 * ThemeToggle — botón único de tema claro/oscuro.
 *
 * Reemplaza las ~5 copias inline del mismo botón sol/luna repartidas por las
 * pantallas públicas (login, verify, portal, alta, corrección). Consume el hook
 * `useDarkMode` (fuente de verdad del tema: clase `.dark` en <html> + localStorage).
 */
import { Sun, Moon } from 'lucide-react'
import clsx from 'clsx'
import { useDarkMode } from '../../hooks/useDarkMode'

export interface ThemeToggleProps {
  className?: string
  /** 'onDark' para barras oscuras (topbar interno): transparente + texto claro. */
  variant?: 'default' | 'onDark'
}

export default function ThemeToggle({ className, variant = 'default' }: ThemeToggleProps) {
  const { dark, toggle } = useDarkMode()
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label="Cambiar tema claro u oscuro"
      title="Cambiar tema"
      className={clsx(
        'flex h-9 w-9 items-center justify-center rounded-lg',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-surface-900',
        variant === 'onDark'
          ? 'text-surface-300 hover:bg-white/10 hover:text-white'
          : 'border border-surface-200 bg-white text-surface-600 hover:text-surface-900 dark:border-surface-700 dark:bg-surface-900 dark:text-surface-300 dark:hover:text-white',
        className,
      )}
    >
      {dark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  )
}
